import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveSeo } from './resolve';
import { setTitle, setMetaName, setMetaProperty, setCanonical } from './head';

// Centralized route-aware head manager. On every route change it re-resolves
// the SEO metadata and rewrites all managed tags so nothing leaks between pages.
export function useSeoHead(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = resolveSeo(pathname);

    setTitle(seo.title);
    setMetaName('description', seo.description);
    setMetaName('keywords', seo.keywords);
    setCanonical(seo.canonical);

    // Open Graph
    setMetaProperty('og:type', seo.ogType);
    setMetaProperty('og:title', seo.title);
    setMetaProperty('og:description', seo.description);
    setMetaProperty('og:url', seo.canonical);
    if (seo.ogImage) setMetaProperty('og:image', seo.ogImage);

    // Twitter Card
    setMetaName('twitter:card', 'summary_large_image');
    setMetaName('twitter:title', seo.title);
    setMetaName('twitter:description', seo.description);
    if (seo.ogImage) setMetaName('twitter:image', seo.ogImage);
  }, [pathname]);
}